import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

interface Props {
  size?: number;
  className?: string;
}

const DraftModificationRequestIcon = ({ size = 24, className }: ClassAttributes<SVGElement> & Props) => (
  <Root
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    version="1.1"
    width={size}
    height={size}
    className={className}
  >
    <path d="M249.24,7a19.33,19.33,0,1,0,0,38.65,204.91,204.91,0,1,1-171.82,93.4l17.93,13.4a7.12,7.12,0,0,0,11.23-4.23l12.07-57.08A19.32,19.32,0,0,0,121.2,79l5.46-25.8a7.11,7.11,0,0,0-10.35-7.73L30.92,91.67a7.13,7.13,0,0,0-.87,12l16.33,12.21A242.47,242.47,0,0,0,5.77,250.46c0,134.48,109,243.45,243.47,243.47s243.44-109,243.46-243.47S383.71,7,249.24,7Z" />
    <rect x="163.88" y="200.22" width="140.49" height="20.25" />
    <rect x="163.88" y="246.94" width="140.49" height="20.25" />
    <rect x="163.88" y="293.67" width="89.55" height="20.25" />
    <path d="M115.94,139.85v249.4H277.16l1.75-2L335.42,334l16.88-16V139.85ZM335.42,318H292.73a15.65,15.65,0,0,0-15.57,15.58v37H132.83v-212H335.42Z" />
    <path d="M359.58,100.25h0Z" />
    <path d="M403.6,128.56h0l-.07-.08h0l-.09-.08L386.6,111.58s0,0,0,0a38.62,38.62,0,0,0-54.6,0l-15.82,15.81-6,6L179.08,264.47V336h71.51L381.67,204.9l6-6,15.82-15.83a38.62,38.62,0,0,0,.12-54.49ZM242,315.14h-42v-42l125-125,42,42Zm146.8-146.8-9.82,9.81-42-42,9.81-9.82a17.78,17.78,0,0,1,25.13,0l16.91,16.9a17.79,17.79,0,0,1,0,25.14Z" />
    <path d="M359.58,100.25h0Z" />
    <path d="M242,315.14h-42v-42l125-125,42,42Zm146.8-146.8-9.82,9.81-42-42,9.81-9.82a17.78,17.78,0,0,1,25.13,0l16.91,16.9a17.79,17.79,0,0,1,0,25.14Z" />
  </Root>
);

const Root = styled('svg')({ fill: 'currentColor' });

export default DraftModificationRequestIcon;
